import React from 'react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'secondary' | 'white' | 'gray';
  className?: string;
  'aria-label'?: string;
}

const LoadingSpinner = React.forwardRef<HTMLDivElement, LoadingSpinnerProps>(
  (
    {
      size = 'md',
      color = 'primary',
      className = '',
      'aria-label': ariaLabel = 'Loading...',
      ...props
    },
    ref
  ) => {
    const sizeClasses = {
      sm: 'h-4 w-4',
      md: 'h-6 w-6',
      lg: 'h-8 w-8',
      xl: 'h-12 w-12',
    };

    const colorClasses = {
      primary: 'text-xtnd-blue',
      secondary: 'text-xtnd-dark',
      white: 'text-white',
      gray: 'text-gray-600',
    };

    return (
      <div
        ref={ref}
        role="status"
        aria-label={ariaLabel}
        className={`
          inline-block animate-spin rounded-full border-2 border-solid border-current border-r-transparent
          ${sizeClasses[size]}
          ${colorClasses[color]}
          ${className}
        `.trim()}
        {...props}
      >
        <span className="sr-only">{ariaLabel}</span>
      </div>
    );
  }
);

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;
